import React from 'react';
import { toast } from 'react-hot-toast';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { PRICE_SELECTED, START } from 'shared/data/quoteSteps';
import { validate } from 'us_pcb_assembly/store/validator';
import { doAddToCart } from 'shared/thunks';

import CartComponent from 'shared/components/CartComponent';
import { selectAssemblyDataForCart } from 'us_pcb_assembly/store/selectors';

const Cart = () => {
  const dispatch = useDispatch();

  const { assemblyProps, assemblyDataForForms } = useSelector(selectAssemblyDataForCart);

  const {
    unitPrice,
    totalPrice,
    quantity,
    parametersChanged,
    leadTime,
    addingToCart: loading,
  } = assemblyProps;

  const {
    quoteStep,
    currentVariant,
    parameters,
  } = assemblyDataForForms;

  const buildForm = () => {
    const form = new FormData();

    _.each(parameters, (value, key) => {
      if (key === 'quantities') {
        parameters[key].forEach((qty) => {
          form.append(`parameters[${key}][]`, qty);
        });
      } else {
        form.append(`parameters[${key}]`, value);
      }
    });

    form.append('variant_id', currentVariant);
    const input_file = document.querySelector(`#gerber-file`);
    const file = input_file ? input_file.files[0] : null;
    if (file) form.append('parameters[filename]', file);

    return form;
  };

  const onAddToCart = async () => {
    if (quoteStep === START || totalPrice <= 0) {
      toast.error('Please select some product before adding to cart');
      return;
    }

    if (!dispatch(validate())) return;


    const form = buildForm();

    try {
      await dispatch(doAddToCart(form)).unwrap();
      // eslint-disable-next-line no-undef
      window.location.href = '/cart';
    } catch (e) {
      toast.error(Spree.translations.add_to_cart_error);
    }
  };

  const properties = [
    {
      label: 'Qty:',
      value: quantity,
    }, {
      label: 'Lead Time:',
      value: leadTime && `${leadTime} ${parameters.supplier_selected === 'assembly-mx' ? 'weeks' : 'days'}`,
    },
  ];

  return (
    <div>
      <CartComponent
        disabled={quoteStep !== PRICE_SELECTED || _.lt(totalPrice, 0)}
        quoteStep={quoteStep}
        properties={properties}
        unitPrice={unitPrice}
        totalPrice={totalPrice}
        parametersChanged={parametersChanged}
        onAddToCart={onAddToCart}
        loading={loading} />
    </div>
  );
};

export default Cart;
